import { Box, EmptyState, Text, VStack } from '@chakra-ui/react';
import BundleLogo from '@/icons/BundleLogo.tsx';
import { Link } from '@tanstack/react-router';
import { Routes } from '@/routes.ts';

export const NotFound = () => {
	return (
		<EmptyState.Root size="lg">
			<EmptyState.Content>
				<EmptyState.Indicator></EmptyState.Indicator>
				<Box h="20">
					<Box asChild h="100%" w="auto">
						<BundleLogo />
					</Box>
				</Box>
				<VStack textAlign="center">
					{/* TODO: chakra-migration fontSize.token — 4xl/bold display type sits above the textStyle ramp (display is 30px/600) */}
					<Text fontSize="4xl" fontWeight="bold" lineHeight="1">
						404
					</Text>
					<EmptyState.Title>Page not found</EmptyState.Title>
					<EmptyState.Description>
						<Link to={Routes.DASHBOARD}>Go home</Link>
					</EmptyState.Description>
				</VStack>
			</EmptyState.Content>
		</EmptyState.Root>
	);
};
